import React from 'react'
import Wrapper from '../../components/wrapper'
import GlobalStyles from '../../assets/styles/global'
//
import Rulebok from './rulebok'

export default function RulebookHOC({ ...props }) {
  return (
    <>
      <GlobalStyles />
      <Wrapper>
        <Rulebok {...props} />
      </Wrapper>
    </>
  )
}
